<template>

    <div class="popup active">
        <div class="notice_popup human int">
            <div class="close">
                <img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
            </div>
            
			<div class="tit">공지 이미지</div>

            <div class="prj_name">
                <span class="name" title="">공지사항</span>
            </div>
            <div class="select-btn">
                <div class="btn" @click="move()">오늘보지않기</div>
				<div class="btn" @click="$emit('close', false)">확인</div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

	components : {		
	},

	props: ['param'],

	data() {
		return {
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		move() {
			try {
				this.$store.commit('hoverPopupDay', new Date().format('yyyyMMdd'));
			} catch(e) {
				// console.log(e);
			}
			
			// console.log(this.$store.state);
			this.$emit('close', true);	
		}
	},
};
</script>
